/** @module config/twoPartTransitionWords */

/**
 * Returns an array with two-part transition words to be used by the assessments.
 * @type {Array} The array filled with two-part transition words.
 */
export default [ [ "albo", "albo" ], [ "ani", "ani" ], [ "czy", "czy" ], [ "im", "tym" ], [ "tak", "jak" ] ];

